import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import type { Organization } from '../../common/organization';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type AddOrganizationSuccessResponseType = { message: string };

async function addOrganization(payload: Omit<Organization, 'id'>): Promise<AddOrganizationSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.ORGANIZATIONS.INDEX}`, payload);
	return getResponse<AddOrganizationSuccessResponseType>(response.data);
}

export function addOrganizationOptions() {
	return mutationOptions({
		mutationFn: (payload: Omit<Organization, 'id'>) => addOrganization(payload),
		onSuccess: async (data) => {
			console.log('Organization added successfully:', data);
			toast.success(t('admin.toast.organizationAdded'));
			await queryClient.invalidateQueries({ queryKey: ['organizations'] });
		},
		onError: (error) => toastApiError(error),
	});
}
